import React from 'react';
import cx from 'classnames';
import { withBlockExtensions } from '@plone/volto/helpers';
import BodyComponent from '@eeacms/volto-group-block/components/manage/Blocks/Group/Body';

const View = (props) => {
  const { data } = props;
  const CustomTag = `${data.as || 'div'}`;
  const customId = data?.title
    ?.toLowerCase()
    ?.replace(/[^a-zA-Z-\s]/gi, '')
    ?.trim()
    ?.replace(/\s+/gi, '-');

  return (
    <CustomTag
      id={customId}
      className={cx(
        'section-block',
        data.className,
        data.leftBlock && `vertical-align-${data.leftBlock}`,
        data.swapOnMobile && 'reverse-on-mobile',
      )}
    >
      <BodyComponent {...props} />
    </CustomTag>
  );
};

export default withBlockExtensions(View);
